/* ============================================================
   Garrnish header behavior
   - Mobile drawer toggle (menu ↔ x), closes on link tap
   - Promo bar height published as --gn-promo-h for the sticky stack
   - Scroll shadow past 8px (passive listener)
   - Cart badge count kept in sync with the Shopify cart
   ============================================================ */
(function () {
  'use strict';
  if (window.__gnHeaderInit) return;
  window.__gnHeaderInit = true;

  var header = document.querySelector('[data-gn-header]');
  if (!header) return;

  /* ---- Promo bar height ----
     The header sticks directly beneath the promo bar. Publishing the real
     measured height means the stack stays correct when the promo text wraps
     to two lines, when the bar is toggled off, or when web fonts load and
     change the line height. Reads 0 when no promo bar is present. */
  var promo = document.querySelector('.gn-promo');

  function setPromoHeight() {
    var h = promo ? Math.round(promo.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--gn-promo-h', h + 'px');
  }

  setPromoHeight();

  if (promo) {
    if (window.ResizeObserver) {
      new ResizeObserver(setPromoHeight).observe(promo);
    } else {
      window.addEventListener('resize', setPromoHeight);
    }
  }

  /* ---- Mobile drawer ---- */
  var burger = header.querySelector('[data-gn-burger]');
  var drawer = header.querySelector('[data-gn-drawer]');

  function setDrawer(open) {
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    drawer.classList.toggle('is-open', open);
    if (open) {
      drawer.removeAttribute('hidden');
    } else {
      drawer.setAttribute('hidden', '');
    }
  }

  if (burger && drawer) {
    burger.addEventListener('click', function () {
      setDrawer(burger.getAttribute('aria-expanded') !== 'true');
    });
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('a')) setDrawer(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && burger.getAttribute('aria-expanded') === 'true') {
        setDrawer(false);
        burger.focus();
      }
    });
  }

  /* ---- Scroll shadow ---- */
  var scrolled = false;
  function onScroll() {
    var sc = window.scrollY > 8;
    if (sc !== scrolled) {
      scrolled = sc;
      header.classList.toggle('is-scrolled', sc);
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---- Cart badge sync ---- */
  var badge = header.querySelector('[data-gn-cart-count]');
  var cartLink = header.querySelector('[data-gn-cart]');

  function setCount(n) {
    if (!badge) return;
    badge.textContent = n;
    badge.classList.toggle('is-empty', !n);
    if (cartLink) {
      cartLink.setAttribute('aria-label', n ? 'Cart (' + n + ' items)' : 'Cart');
    }
  }

  function refreshCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCount(cart.item_count); })
      .catch(function () { /* keep last known count */ });
  }

  // Expose for other scripts (e.g. the sticky buy bar)
  window.gnRefreshCartCount = refreshCount;

  // Watch for ajax cart mutations from any script on the page
  // (theme ajax cart, PageFly, apps) by wrapping fetch + XHR.
  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?/;

  var origFetch = window.fetch;
  window.fetch = function () {
    var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
    var p = origFetch.apply(this, arguments);
    if (CART_MUTATION.test(url)) {
      p.then(function () { refreshCount(); }).catch(function () {});
    }
    return p;
  };

  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (url && CART_MUTATION.test(url)) {
      this.addEventListener('load', refreshCount);
    }
    return origOpen.apply(this, arguments);
  };

  // Also refresh when the tab regains focus (cart changed in another tab)
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) refreshCount();
  });
})();